var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHealth = function SvgHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 2.446 9.497.095a1.402 1.402 0 0 0-1.012 0l-5.878 2.35a1.356 1.356 0 0 0-.85 1.267v2.252a14.47 14.47 0 0 0 5.878 11.602A2.27 2.27 0 0 0 8.973 18a2.27 2.27 0 0 0 1.374-.434 14.469 14.469 0 0 0 5.896-11.639V3.676a1.357 1.357 0 0 0-.868-1.23Zm-.054 3.518a13.564 13.564 0 0 1-5.525 10.905 1.356 1.356 0 0 1-1.61 0A13.564 13.564 0 0 1 2.661 5.964V3.712a.452.452 0 0 1 .28-.425L8.82.936a.452.452 0 0 1 .344 0l5.878 2.35a.452.452 0 0 1 .28.426v2.252Z",
    fill: "#5C7AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 6.264H10.8V4.003a.452.452 0 0 0-.453-.452H7.635a.452.452 0 0 0-.453.452v2.26h-2.26a.452.452 0 0 0-.453.453v2.713a.452.452 0 0 0 .453.452h2.26v2.26a.452.452 0 0 0 .452.453h2.713a.452.452 0 0 0 .453-.452V9.88h2.26a.452.452 0 0 0 .452-.452V6.716a.452.452 0 0 0-.452-.452Zm-.452 2.713h-2.26a.452.452 0 0 0-.453.452v2.26H8.087V9.43a.452.452 0 0 0-.452-.452H5.373V7.168h2.26a.452.452 0 0 0 .453-.452v-2.26h1.808v2.26a.452.452 0 0 0 .452.452h2.261v1.809Z",
    fill: "#5C7AFF"
  })));
};

export default SvgHealth;